import React, { Component } from 'react'
import { postedJobsCount, postJob } from '../../action/jobs';
import PostAJob from '../../old_Components/PostAJob/PostAJob'
import constant from '../../constant'
import Swal from 'sweetalert2';
import AsideRightMenu from "../../old_Components/Dashboard/AsideRightMenu";
import Shimmer from '../../old_Components/Common/Shimmer';
import { getStorage, setStorage } from '../../utils';
import EnterSecurityCode from '../../old_Components/Common/EnterSecurityCode';
import moment from 'moment';
import { verifySecurityCode } from '../../action/securitypin';
import ModalWindow from '../../old_Components/Common/ModalWindow1';
export default class JobPosting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            LISTNING_TYPE: {
                name: 'LISTNING_TYPE', value: 3, options: [
                    { value: '1', name: 'Regular' },
                    { value: '2', name: 'Featured' },
                    { value: '3', name: 'Premium' }
                ], error: '', isRequired: false
            },
            premiumCount: undefined,
            totaljobsbalance: undefined,
            status: undefined
        }
    }
    componentDidMount() {
        document.title = constant.title.PostPremiumJob
        postedJobsCount().then(res => {
            if (res.status) {
                this.setState({ premiumCount: res.result.premium.total, totaljobsbalance: res.result.totaljobsbalance })
            }
            else {
                alert(res.error)
            }
        }).catch(error => {
            alert(error)
        })
    }

    onSubmitPIN = (PIN) => {
        debugger
        verifySecurityCode(PIN).then(res => {
            if (res.status) {
                if (res.result) {
                    setStorage(constant.keys.Premium_Job_Post_Session, moment().format('X'))
                    window.location.reload()
                }
                else {
                    this.setState({ status: 'Enter Correct PIN' })

                }
            }
        })
    }
    onSubmit = (model) => {
        postJob(model).then(res => {
            if (res.status) {
                this.props.history.push('/dashboard')
                this.setState({ showLoader: false })
                Swal.fire({
                    icon: 'success',
                    text: res.result.message,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 5000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                text: error,
                timer: 5000,
                showCancelButton: false,
                showConfirmButton: false
            })
        })
    }
    render() {
        const { LISTNING_TYPE, premiumCount, totaljobsbalance, status } = this.state
        return (
            <React.Fragment>
                {/* {!getStorage(constant.keys.Premium_Job_Post_Session) && <ModalWindow>
                    <EnterSecurityCode
                        status={status}
                        onSubmitPIN={(PIN) => this.onSubmitPIN(PIN)}
                    />
                </ModalWindow>
                } */}
                {/* {!getStorage(constant.keys.Premium_Job_Post_Session) && <section className="pricing-area padding-top-100px padding-bottom-80px">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 mt-3">
                                <AsideRightMenu />
                            </div>
                            <div className="col-md-9 padding-top-20px">
                              

                            </div>
                        </div>
                    </div>
                </section>} */}


                {totaljobsbalance && premiumCount < totaljobsbalance.PREMIUM_POSTING && <PostAJob
                    onSubmit={this.onSubmit}
                    LISTNING_TYPE={LISTNING_TYPE.value}
                />}
                {totaljobsbalance && premiumCount >= totaljobsbalance.PREMIUM_POSTING && <section className="pricing-area padding-top-100px padding-bottom-80px">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 mt-3">
                                <AsideRightMenu />
                            </div>
                            <div className="col-md-9 padding-top-20px">
                                <div class="alert alert-danger" role="alert">
                                    <span> You do not have an active Subscription for Job Posting on JobzShala. <a href={constant.component.JobPackage.url} > Click Here </a> to get JobzShala Subscription.</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>}
                {totaljobsbalance === undefined && <section className="pricing-area padding-top-100px padding-bottom-80px">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 mt-3">
                                <AsideRightMenu />
                            </div>
                            <div className="col-md-9 padding-top-20px">
                                <Shimmer />
                            </div>
                        </div>
                    </div>
                </section>}
            </React.Fragment>
        )
    }
}
